import { axios } from '@Api/axiosClient';
import type { DashboardContext } from 'certifid-v2-client-hub-shared';

export const getDashboardContextApi = async (): Promise<DashboardContext> => {
    const response = await axios.get('api/Navigation/GetDashboardContext');
    return response?.data;
};
